import { useTranslation } from "@pancakeswap/localization";
import { useToast } from "@pancakeswap/uikit";
import { ToastDescriptionWithTx } from "components/Toast";
import { useCallWithMarketGasPrice } from "hooks/useCallWithMarketGasPrice";
import { useWrapped } from "hooks/useContract";
import { useUserRejected } from "hooks/useUserRejected";
import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "state";
import { actionDispatchAssetMessage } from "state/asset/actions";
import { BuysType } from "state/asset/type";

interface BuysProps {
    nftBalance: number,
    nftId: number
}

export const useListp2p = (
    nftAddress: string,
    buyer: string,
    buys: BuysType[],
    amount: number,
    price: string,
    account: string,
    chainId: number,
    onDismiss: any
) => {
    const { t } = useTranslation();
    const [requestedListp2p, setRequestListp2p] = useState(false);
    const { toastSuccess, toastError } = useToast();
    const { callWithMarketGasPrice } = useCallWithMarketGasPrice();
    const [pendingListp2p, setPenddingListp2p] = useState(false);
    const contractWrapped = useWrapped(nftAddress);
    const dispatch = useDispatch<AppDispatch>();
    const { handleRejected } = useUserRejected();

    const handleListp2p = useCallback(async () => {
        setPenddingListp2p(true);
        try {
            const buysSort = buys.sort((a, b) => a.nftBalance - b.nftBalance);
            const newData: BuysProps[] = [...buysSort];
            let amountBuy = amount;
            const resultFilter: BuysProps[] = [];
            for (let i = 0; i < newData.length && amountBuy > 0; i++) {
                const element = newData[i];
                const quantityToBuy = Math.min(amountBuy, element.nftBalance);
                resultFilter.push({
                    nftId: element.nftId,
                    nftBalance: quantityToBuy
                });
                newData[i].nftBalance -= quantityToBuy;
                amountBuy -= quantityToBuy;
            }
            const tokenIds = resultFilter.map(item => (item.nftId));
            const amounts = resultFilter.map(item => (item.nftBalance));

            const tx = await callWithMarketGasPrice(contractWrapped, "listP2P", [buyer, tokenIds, amounts, price]);
            const receipt = await tx.wait();
            if (receipt.status) {
                dispatch(actionDispatchAssetMessage({ messageHash: receipt.transactionHash }));
                setPenddingListp2p(false);
                toastSuccess(t("Bán thỏa thuận thành công"), <ToastDescriptionWithTx txHash={receipt.transactionHash} />);
                setRequestListp2p(true);
                onDismiss()
            } else {
                setPenddingListp2p(false);
                toastError(
                    t("Đã có lỗi xảy ra"),
                    t("Xác nhận giao dịch, và đảm bảo rằng bạn đủ token trong ví để xử lý giao dịch!")
                );
            }
        } catch (e) {
            console.error(e);
            handleRejected(e);
            setPenddingListp2p(false);
        }
    }, [amount, buyer, buys, callWithMarketGasPrice, contractWrapped, dispatch, handleRejected, onDismiss, price, t, toastError, toastSuccess]);
    return { handleListp2p, requestedListp2p, pendingListp2p };
};
